import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = (theme) => ({
  inline: {
    flexDirection: 'row !important',
  },
  label: {
    fontWeight: '500',
    color: theme.palette.text.primary,
  },
});

class FormRadioGroup extends PureComponent {
  handleChange = (event, value) => {
    const { input, onChangeCustom } = this.props;

    input.onChange(value);

    if (onChangeCustom) onChangeCustom(event, value);
  };

  render() {
    const { children, classes, className, inline, input, label } = this.props;

    return (
      <FormControl className={className} component="fieldset">
        <FormLabel component="legend">{label}</FormLabel>
        <RadioGroup
          aria-label="Timing"
          className={classnames({ [classes.inline]: inline })}
          onChange={this.handleChange}
          {...input}
          // https://github.com/react-dnd/react-dnd/issues/701
          onDrop={(e) => e.preventDefault()}
        >
          {children}
        </RadioGroup>
      </FormControl>
    );
  }
}

FormRadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  inline: PropTypes.bool,
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChangeCustom: PropTypes.func,
};

FormRadioGroup.defaultProps = {
  inline: false,
  label: '',
  onChangeCustom: undefined,
};

export default withStyles(styles)(FormRadioGroup);
